import { render } from "./BusinessData.vue?vue&type=template&id=dd509dfe"
import script from "./BusinessData.vue?vue&type=script&lang=js"
export * from "./BusinessData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__